/*
* @Description: 历史记录
* @Author: hansaibo
* @Date: 2023-12-04 10:48:25
* @LastEditors: hansaibo
* @LastEditTime: 2023-12-04 11:51:07
*/
<template>
  <div class="queue-manager" @keyup.enter="enterSearch">
    <el-form class="table-search-bar" :model="regionHistoryForm" ref="regionHistoryForm" inline label-width="70px">
      <el-form-item label="调整方向" prop="adjustDirection">
        <el-select v-model="regionHistoryForm.adjustDirection" placeholder="请选择">
          <el-option
            v-for="item in adjustDirectionArr"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="协议编码" prop="agreementCode">
        <el-input v-model="regionHistoryForm.agreementCode" placeholder="请输入协议编码"></el-input>
      </el-form-item>
      <el-form-item label="商品名称" prop="itemName">
        <el-input v-model="regionHistoryForm.itemName" placeholder="请输入商品名称"></el-input>
      </el-form-item>
      <el-form-item label="车牌号" prop="plateNum">
        <el-input v-model="regionHistoryForm.plateNum" placeholder="请输入车牌号"></el-input>
      </el-form-item>
      <el-form-item label="订单编号" prop="orderNum" v-if="orderType === '1'">
        <el-input v-model="regionHistoryForm.orderNum" placeholder="请输入订单编号"></el-input>
      </el-form-item>
      <el-form-item label="调整结果" prop="adjustResults" >
        <el-select v-model="regionHistoryForm.adjustResults" placeholder="请选择">
          <el-option
            v-for="item in adjustResultsAry"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发起时间" prop="createTime">
        <el-date-picker
          v-model="regionHistoryForm.createTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          :defaultTime="['00:00:00', '23:59:59']">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜 索</el-button>
        <el-button type="primary" @click="reset">重 置</el-button>
      </el-form-item>
    </el-form>
    <el-tabs v-model="orderType" @tab-click="onCarTypesChange">
      <el-tab-pane v-for="item in carTypes"
        :key="item.id"
        :label="item.label"
        :name="item.id">
      </el-tab-pane>
    </el-tabs>
    <el-table
      :data="historyList"
      style="width: 100%">
      <el-table-column
        prop="agreementNo"
        label="协议号"
        width="130"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        v-if="orderType === '1'"
        prop="orderNum"
        label="订单编号"
        width="130"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="driverName"
        label="司机姓名"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="plateNum"
        label="车牌号"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        label="提货单位名称"
        prop="consumerName"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="itemName"
        label="商品名称"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="deliveryArea"
        label="调整方向"
        :show-overflow-tooltip="true"
      >
       <template slot-scope="scope">
         <span>{{scope.row.adjustDirection==1 ? '至百万方罐区' : '至京博石化厂区'}}</span>
       </template>
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="调整时间"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="updatePerson"
        label="调整人"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="adjustResults"
        label="调整结果"
        :show-overflow-tooltip="true"
      >
      <template slot-scope="scope">
         <span>{{scope.row.adjustResults==0 ? '失败' : '成功'}}</span>
      </template>
      </el-table-column>
      <el-table-column
        prop="reasonsFailure"
        label="失败原因"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="historyListState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="historyListState.historyTotal"
      :current-page="historyListState.pageNo"
      background>
    </el-pagination>
    <el-row class="export-row" type="flex" justify="end">
      <div class="mr10">
        每页
        <el-select class="width100" v-model="pageSize" @change="handleExportSizeChange">
          <el-option v-for="item in sizeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
          </el-option>
        </el-select>
        条
      </div>
      <div class="mr10">
        第
        <el-select class="width100" v-model="pageNo">
          <el-option
            v-for="item in pageOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        页
      </div>
      <div class="">
        <el-button type="primary" @click="handleExport">导出为CSV文件</el-button>
      </div>
      </el-row>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { formatTime } from '../../../../common/utils'

export default {
  name: 'regionHistory',
  components: { },
  data () {
    return {
      checkDialogShow: false,
      regionHistoryForm: {
        adjustDirection: '',
        agreementCode: '',
        itemName: '',
        plateNum: '',
        adjustResults: '',
        orderNum: '',
        createTime: [formatTime(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1), true), formatTime(new Date(), true)]
      },
      exportForm: {
        size: 1000,
        page: 1
      },
      pageNo: 1,
      pageSize: 100,
      sizeOptions: [
        {
          label: '100',
          value: 100
        },
        {
          label: '300',
          value: 300
        },
        {
          label: '500',
          value: 500
        },
        {
          label: '1000',
          value: 1000
        }
      ],
      orderType: '1',
      carTypes: [
        {
          id: '1',
          label: '商城车辆'
        }
        // ,
        // {
        //   id: '2',
        //   label: '调拨车辆'
        // }
      ],
      statusArr: ['未预约', '已预约', '已排队', '未到场', '取消预约'],
      adjustDirectionArr: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '1',
          label: '京博石化厂区至百万方'
        },
        {
          value: '2',
          label: '百万方至京博石化厂区'
        }
      ],
      adjustResultsAry: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '1',
          label: '成功'
        },
        {
          value: '0',
          label: '失败'
        }
      ]
    }
  },
  methods: {
    ...mapActions(['getRegionHistoryList', 'exportRegionHistoryList']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    handleSearch () {
      const params = {
        ...this.regionHistoryForm,
        orderType: this.orderType,
        pageNo: 1,
        startTime: this.regionHistoryForm.createTime ? this.regionHistoryForm.createTime[0] : '',
        endTime: this.regionHistoryForm.createTime ? this.regionHistoryForm.createTime[1] : ''
      }
      this.getRegionHistoryList(params)
    },
    reset () {
      this.$refs['regionHistoryForm'].resetFields()
      this.handleSearch()
    },
    handleSizeChange (val) {
      this.getRegionHistoryList({ pageNo: 1, pageSize: val })
    },
    handleCurrentChange (val) {
      this.getRegionHistoryList({ pageNo: val })
    },
    // 车辆类型切换
    onCarTypesChange (newType) {
      this.handleSearch()
    },
    // 导出每页条数变动监听
    handleExportSizeChange (val) {
      this.pageNo = 1
    },
    // 导出
    handleExport () {
      if (!Array.isArray(this.historyList) || this.historyList.length === 0) {
        this.$message({
          message: '暂无数据',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const params = {
          orderType: this.orderType,
          adjustDirection: this.regionHistoryForm.adjustDirection,
          agreementCode: this.regionHistoryForm.agreementCode,
          itemName: this.regionHistoryForm.itemName,
          orderNum: this.regionHistoryForm.orderNum,
          adjustResults: this.regionHistoryForm.adjustResults,
          startTime: this.regionHistoryForm.createTime ? this.regionHistoryForm.createTime[0] : '',
          endTime: this.regionHistoryForm.createTime ? this.regionHistoryForm.createTime[1] : '',
          pageNo: this.pageNo,
          pageSize: this.pageSize
        }
        this.exportRegionHistoryList({ ...params }).then((res) => {
          function createDownloadFile () {
            let blob = new Blob([res])
            let link = document.createElement('a')
            link.download = '历史调整记录表.xls'
            link.style.display = 'none'
            link.target = '_Blank'
            link.href = window.URL.createObjectURL(blob)
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(link.href)
          }
          createDownloadFile()
          this.$message.success('导出成功')
        })
      }).catch(() => {})
    }
  },
  mounted () {
    this.handleSearch()
  },
  computed: {
    ...mapState({
      historyList: state => state.regionManager.historyList,
      historyListState: state => state.regionManager.historyListState
    }),
    pageOptions () {
      const total = this.historyListState.historyTotal
      const size = this.pageSize
      let totalPage = Math.floor(total / size)
      if (total % size) {
        totalPage++
      }
      const arr = []
      for (let index = 1; index <= totalPage; index++) {
        arr.push({
          label: index,
          value: index
        })
      }
      return arr
    }
  }
}
</script>
